import React from "react";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import BlockIcon from '@material-ui/icons/Block';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

//0 черновик
//1 ведется набор
//2 запись закрыта
//3 завершено (архив)

export const SmallStateIcon = (stateid, classname) => {
  switch(stateid) {
    case 0:
      return <EditOutlinedIcon/>;
    case 1:
      return <AccessTimeIcon/>;
    case 2:
      return <BlockIcon/>;
    case 3:
      return <CheckCircleOutlineIcon/>;
    default:
      return <></>;
  }
};

export const StateTextColor = stateid => {
  switch(stateid) {
    case 0:
      return "#778899";
    case 1:
      return "#007FBD";
    case 2:
      return "#F15454";
    case 3:
      return "#778899";
    default:
      return "#000000";
  }
};

export const ColoredStateIcon = (stateid) => {
  switch(stateid) {
    case 0:
      return <EditOutlinedIcon style={{ color: "#778899", marginBottom: "-6px"}}/>;
    case 1:
      return <AccessTimeIcon style={{ color: "#007FBD", marginBottom: "-6px"}}/>;
    case 2:
      return <BlockIcon style={{ color: "#F15454", marginBottom: "-6px"}}/>;
    case 3:
      return <CheckCircleOutlineIcon style={{ color: "#778899", marginBottom: "-6px"}}/>;
    default:
      return <></>;
  }
};
